import { useQuery } from "@apollo/client";
import {
  REFERRAL_PROGRAM,
  ReferralProgramStatus,
} from "MVVM/GraphQL/referralProgram";
import { useUser } from "MVVM/Hooks/useUser";

export const useReferralProgramEligibility = () => {
  const { allstarUser } = useUser();
  const owner = allstarUser?.user?._id;
  const { data, loading, error } = useQuery<{
    referralProgram: ReferralProgramStatus;
  }>(REFERRAL_PROGRAM, {
    skip: !owner,
    fetchPolicy: "no-cache",
  });
  const program = data?.referralProgram;
  return Boolean(
    owner &&
      !loading &&
      !error &&
      program?.userId === owner &&
      program?.eligible,
  );
};
